// src/components/aivaFace.js — o rosto da AIVA (SVG, ~2KB, escala de 20 a 130px).
// Substitui o PNG /aiva-rosto.png: vetor, segue o tema, respira, pisca e TEM EXPRESSÃO.
//
//   aivaFace(34)                → neutra
//   aivaFace(34, 'pensando')    → enquanto a resposta carrega
//   aivaFace(34, 'feliz')       → insight positivo
//   aivaFace(34, 'preocupada')  → alerta
//   aivaFace(34, 'erro')        → a chamada falhou
//   aivaFace(34, 'dormindo')    → plano Basic
//
// A boca é um <path> que MORFA entre as curvas (transition:d) — a emoção nasce do traço.
import './aivaFace.css';

export const AIVA_BOCAS = {
  neutra:     'M46 60.5c2.6 2.4 5.4 2.4 8 0',
  atenta:     'M46.5 60.5c2.4 1.8 4.6 1.8 7 0',
  pensando:   'M47 61.5c2.2-1.1 4.6-1.1 6.8 0',
  falando:    'M46 60c2.6 3 5.4 3 8 0',
  feliz:      'M44.5 59c3.4 5 7.6 5 11 0',
  preocupada: 'M46 63c2.6-2.6 5.4-2.6 8 0',
  erro:       'M46 63.5c2.6-3 5.4-3 8 0',
  dormindo:   'M47.5 61.5h5',
};

export function aivaFace(size = 34, expressao = 'neutra') {
  const exp = AIVA_BOCAS[expressao] ? expressao : 'neutra';
  return `<span class="aiva-face ${exp}" style="width:${size}px;height:${size}px" role="img" aria-label="AIVA">
  <svg viewBox="0 0 100 100" aria-hidden="true">
    <g class="af-corpo">            <!-- balanço lento (idle) + inclinação por expressão -->
      <g class="af-cabeca">         <!-- respiração -->
        <path class="af-pele" d="M31 42c0-13 8-21 19-21s19 8 19 21c0 16-8 29-19 29S31 58 31 42z"/>
        <circle class="af-pele" cx="30" cy="48" r="3.4"/><circle class="af-pele" cx="70" cy="48" r="3.4"/>
        <path class="af-cabelo" d="M50 13c-14 0-23 10-23 26 0 8 1 14 2 20 .4 2.4 4 2.6 4.2 0 .5-5.4-.8-10.6.4-15.4 5.6-.4 11-2.6 16.4-6.6 5.4 4 10.8 6.2 16.4 6.6 1.2 4.8-.1 10-.4 15.4-.2 2.6 3.8 2.4 4.2 0 1-6 2-12 2-20 0-16-9-26-23-26z"/>
        <circle class="af-blush" cx="37" cy="52" r="4"/><circle class="af-blush" cx="63" cy="52" r="4"/>
        <g class="af-tracos">       <!-- feições: deslizam junto com a cabeça (paralaxe) -->
          <path class="af-sobr esq" d="M38 41.5c2-1.6 5-1.6 6.8 0"/>
          <path class="af-sobr dir" d="M55.2 41.5c1.8-1.6 4.8-1.6 6.8 0"/>
          <g class="af-olhos">      <!-- olhada solta: o olhar passeia sozinho -->
            <ellipse class="af-olho" cx="41.4" cy="47.5" rx="2.6" ry="3.2"/>
            <ellipse class="af-olho" cx="58.6" cy="47.5" rx="2.6" ry="3.2"/>
          </g>
          <path class="af-boca" d="${AIVA_BOCAS[exp]}"/>
          <rect class="af-palpebra" x="36" y="43" width="28" height="9" rx="3"/>
        </g>
      </g>
    </g>
  </svg>
</span>`;
}

// Troca a expressão de um rosto já montado (sem re-render: a boca morfa).
export function aivaExpressao(el, expressao) {
  const face = el?.classList?.contains('aiva-face') ? el : el?.querySelector?.('.aiva-face');
  if (!face) return;
  const exp = AIVA_BOCAS[expressao] ? expressao : 'neutra';
  face.className = 'aiva-face ' + exp;
  const boca = face.querySelector('.af-boca');
  if (boca) boca.setAttribute('d', AIVA_BOCAS[exp]);
}
